import React from "react";
import { test_prod_aws_payment } from "../../utils/payment_fetch";

const TestPaymentForm = () => {
  const hardcodedData = {
    name: "Pradeep Argal",
    contactNo: "+918962093654",
    cardNumber: "1234567812345678",
    amount: "1",
  };

  const handleSubmit = async () => {
    try {
      const response = await test_prod_aws_payment(hardcodedData);
    } catch (error) {
      console.error("Error submitting payment", error);
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "auto", padding: "20px" }}>
      <h2>Test Hardcoded Payment</h2>
      <button onClick={handleSubmit} style={{ marginTop: "10px" }}>
        Pay ₹{hardcodedData.amount} Now
      </button>
    </div>
  );
};

export default TestPaymentForm;
